<template>
<Main v-if="landscape" />
<LandscapeError v-else />
</template>

<script>
import Main from '@/components/Menu/Main.vue'
import LandscapeError from '@/components/Menu/LandscapeError.vue'

export default {
    name: 'App',
    components: {
        Main,
        LandscapeError
    },
    mounted() {
        this.handleOrientationChange();
        window.addEventListener(
            'orientationchange',
            this.handleOrientationChange
        );
        window.addEventListener('resize', this.handleOrientationChange);
    },
    data() {
        return {
            landscape: true,
        };
    },
    methods: {
        handleOrientationChange() {
            let orientation = window.screen.orientation;
            if (orientation === undefined) {
                console.log('UN: ' + window.orientation);
                if (window.orientation !== undefined) {
                    let orientation = window.orientation;
                    switch (orientation) {
                        case -90:
                        case 90:
                            this.landscape = true;
                            break;
                        default:
                            this.landscape = false;
                            break;
                    }
                } else {
                    console.log('IW: ' + window.innerWidth);
                    if (window.innerWidth >= window.innerHeight) {
                        this.landscape = true;
                    } else {
                        this.landscape = false;
                    }
                }
            } else {
                if (orientation.type === "portrait" || orientation.type === "portrait-primary" || orientation.type === "portrait-secondary") {
                    orientation
                        .lock("landscape-primary")
                        .catch((error) => {
                            console.log('ERROR: ' + error);
                            this.landscape = false;
                        })
                        .then(
                            success => {
                                if (success) this.landscape = true
                            },
                            failure => console.log(failure)
                        );
                } else {
                    this.landscape = true;
                }
            }

        }
    }
}
</script>

<style>
@font-face {
    font-family: "Omnes";
    src: local("Omnes"),
        url(/fonts/Omnes/omnes-regular.ttf) format("truetype");
}

html,
body {
    width: 100vw;
    height: 100vh;
    margin: 0;
}

#app,
.app-content {
    width: 100%;
    height: 100%;
}

body>object {
    position: absolute;
}
</style>
